import { useEffect } from "react";

/**
 * useRevealOnScroll — active la classe `.is-visible` sur tous les éléments
 * qui portent `.reveal-on-scroll` dès qu'ils entrent dans le viewport.
 *
 * Utilise IntersectionObserver (natif, aucune dépendance). Une seule instance
 * globale par page — l'observer est créé au mount et déconnecté au unmount.
 */
export function useRevealOnScroll(deps = []) {
  useEffect(() => {
    const nodes = document.querySelectorAll(".reveal-on-scroll:not(.is-visible)");
    if (!nodes.length) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -50px 0px" }
    );
    nodes.forEach((n) => io.observe(n));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
